<template>
<div class="card">
	<div class="card__top" @click="$emit('show-more')">
		<div class="card__top-darken"></div>
		<div class="card__icon" ><slot name="icon"></slot></div>
	</div>
	<div class="card__bottom">
		<div class="card__title mt-1" @click="$emit('show-more')"><slot name="title"></slot></div>
		<div class="card__content"><slot name="content"></slot></div>
	</div>
</div>
</template>

<script>
import customButton from './CustomButton';
import deleteButton from './DeleteButton';
import editButton from './EditButton';
export default {
	components: {
		customButton,
		deleteButton,
		editButton
  },
	props: {
		item: Object,
		rows: Array,
		showEdit: { type: Boolean, default: true },
		showArchive: { type: Boolean, default: true }
	},
	computed: {
      showActions: function () {
        return this.showEdit || this.showArchive;
      }
    },

}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables";

.card {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 205px;
	min-height: 300px;
	margin: 10px;
	flex-shrink: 0;
	color: $light-text-color;

	.dark & {
		color: $dark-grey;
	}

	&__top {
		position: relative;
		display: flex;
		justify-content: center;
		width: 100%;
		height: 165px;
		padding-bottom: 15px;
		background: linear-gradient(to top, rgba(236,236,236,1) 0%, rgba(255,255,255,1) 100%);
		border-radius: 4px 4px 0px 0px;

		.dark & {
			background: linear-gradient(to top, $bg-grey 0%, $bg-black 100%);
		}

		&:hover .card__top-darken {
			opacity: 1;
		}

		&:hover + .card__bottom .card__title {
			text-decoration: underline;
		}
	}

	&__top-darken {
		position: absolute;
		opacity: 0;
		top: 0;
		left: 0;
		width: 205px;
		height: 165px;
		background: linear-gradient(to bottom, rgba(236, 236, 236, 0) 0%, rgba(34, 34, 34, 0.6) 100%);
		transition: opacity 200ms;
		z-index: 1;
		cursor: pointer;
	}

	&__icon {
		display: flex;
		width: 150px;
		height: 150px;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		font-size: 38px;
		font-weight: 900;
		color: $label-color;
		z-index: 0;

		img {
			width: 150px;
			height: 150px;
			z-index: 1;
			flex-shrink: 0;
		}
	}

	&__bottom {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		min-height: 120px;
		padding: 0 10px;
		box-shadow: 0px 5px 7px -1px rgba(0, 0, 0, 0.25);
		border-radius: 8px;
		background-color: #fff;
		margin-top: -5px;
		font-size: 14px;
		z-index: 1;

		.dark & {
			background-color: $bg-black;
		}
	}

	&__title {
		font-size: 18px;
		font-weight: 500;
		cursor: pointer;

		.dark & {
			color: $dark-grey;
		}

		&:hover {
			text-decoration: underline !important;
		}
	}

	&__content {
		display: flex;
		flex-direction: column;
		text-align: left;
		padding: 10px 0;
		color: $label-color;

		.dark & {
			color: $dark-grey;
		}
	}

	&__button {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 90px;
		background-color: transparent;
		border: none;
		color: $light-grey-darken;
		cursor: pointer;

		svg {
			width: 15px;
			height: 15px;
			fill: $main-blue;
		}

		.dark & {
			color: $dark-grey;
		}
	}
}
</style>
